module.exports = __webpack_public_path__ + "img/jewellery_design.aa9d9b3b.jpg";